import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import {
  floorPlan,
  diagrams,
  groundFloor,
  firstFloor,
} from "../css/floor-plan-promo.module.css";

const getFloorPlanPromo = graphql`
  query FloorPlanPromo {
    strapiFloorPlanPromo {
      image {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED, layout: FULL_WIDTH)
        }
      }
      groundFloor {
        publicURL
      }
      firstFloor {
        publicURL
      }
    }
  }
`;

const FloorPlanPromo = () => {
  const data = useStaticQuery(getFloorPlanPromo);

  return (
    <section className={floorPlan}>
      <p>
        All inclusive room rates, free set up time, free parking, wide choice of
        rooms from £12/hour!
      </p>
      <div className={diagrams}>
        <div>
          <figure className={groundFloor}>
            <img src={data.strapiFloorPlanPromo.groundFloor.publicURL} />
            <figcaption>Ground floor</figcaption>
          </figure>
          <figure className={firstFloor}>
            <img src={data.strapiFloorPlanPromo.firstFloor.publicURL} />
            <figcaption>First floor</figcaption>
          </figure>
        </div>
        <p>
          <ul>
            <li>Main hall and stage</li>
            <li>Function room</li>
            <li>Activity room</li>
            <li>Studio</li>
            <li>Meeting room</li>
            <li>Fully equipped quiet training suite</li>
            <li>Free use of snooker tables for banqueting</li>
            <li>Automatic main entrance door for wheelchair access</li>
          </ul>
        </p>
      </div>
    </section>
  );
};

export default FloorPlanPromo;
